import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../components/auth/auth.selector";
import TeamLanding from "../../components/wtf-team/TeamLanding";
import HelmetWrapper from "../../HelmetWrapper";

const WtfTeam = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: Team">
      <TeamLanding userInfoData={userInfoData} />
    </HelmetWrapper>
  );
};

export default WtfTeam;
